angular.module('bb.users').component('bbTeamList', {
  bindings: {},
  controller: TeamListCtrl,
  controllerAs: 'vm',
  template: require('./user_team_list.html'),
});

TeamListCtrl.$inject = ['$scope', '$resource'];

function TeamListCtrl($scope, $resource) {
  const Team = $resource(
    '/team/:teamId',
    { teamId: '@teamId' },
    {
      delete: {
        method: 'POST',
        url: '/team/delete/:teamId',
      },
    },
  );

  const init = function () {
    Team.query().$promise.then(function (data) {
      $scope.teams = data;
      $scope.dataLoaded = true;
    });
  };

  init();

  $scope.delete = function (teamId) {
    swal(
      {
        title: 'Delete Team',
        text: 'Are you sure you want to delete this team?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Yes',
        closeOnConfirm: true,
      },
      function () {
        $scope.dataLoaded = false;
        Team.delete({ teamId }).$promise.then(function () {
          init();
        });
      },
    );
  };

  $scope.addTeam = function () {
    Team.save({
      name: $scope.team.name,
      teamId: $scope.team.id,
    }).$promise.then(function () {
      $('#teamModal').modal('toggle');
      init();
    });
  };

  $scope.editTeam = function (team) {
    $('#teamModal').modal('toggle');
    $scope.team = _.clone(team);
  };
}

export {};
